import { render, staticRenderFns } from "./CompStar.vue?vue&type=template&id=5fc0db86"
import script from "./CompStar.vue?vue&type=script&lang=js"
export * from "./CompStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports